import $ from 'jquery';
import '../../../../jsscripts/jquery/jquery.password_strength.js';
import * as fields from './formfields';
import { tooltipProxy as tooltip } from '../../../smartpak/tooltipproxy.js';
import * as emailStore from '../emailstore.js';

export default function registrationForm({ $form, showPasswordFields, onRegister, asyncVerifyAddress, tokenService }) {
    if (!$form || $form.nodeName.toLowerCase() !== 'form') {
        throw new Error('registrationForm requires a form element parameter');
    }

    const $email = $form.querySelector('#EmailAddress');

    const getData = () => new FormData($form);

    const handleSubmit = async event => {
        event.preventDefault();

        if (!$($form).valid()) {
            return;
        }

        const $submitButton = $form.querySelector('[type="submit"]');

        if (!$form.querySelector('#UpsAddressCorrection')?.checked) {
            await asyncVerifyAddress($form);
        }

        $submitButton.disabled = true;

        const $token = $form.querySelector('#Token');

        if ($token) {
            $token.value = await tokenService();
        }

        $submitButton.disabled = false;

        if (typeof onRegister === 'function') {
            onRegister(Object.fromEntries(getData().entries()));
        }

        $form.removeEventListener('submit', handleSubmit);
        $form.submit();
        $form.addEventListener('submit', handleSubmit);
    };

    barnInformation($form, getData());

    if (showPasswordFields) {
        $form.querySelector('.passwordFields').classList.remove('jsHide');
    }

    tooltip($form.querySelector('.barnCheckTooltip'), {
        trigger: 'hover click',
        content: $form.querySelector('#barnShippingInfo')?.innerHTML,
        placement: 'bottom',
        width: 220
    });

    tooltip($email, {
        trigger: 'focus',
        width: 220
    });

    $form.addEventListener('submit', handleSubmit);

    $form.querySelector('#findBarnLink')?.addEventListener('click', event => {
        event.preventDefault();

        $form.removeEventListener('submit', handleSubmit);
        $form.action = event.target.getAttribute('href');
        $form.submit();
    });

    $form.querySelector('#IsMobilePhoneNumber')?.addEventListener('click', event => {
        var $phone = $form.querySelector('#PhoneNumber'),
            $sms = $form.querySelector('#SmsPhoneNumber');

        if (!$sms) {
            return;
        }

        if ($phone.value.length && event.target.checked) {
            $sms.value = $phone.value;
            return;
        }

        if (!event.target.checked && $sms.value === $phone.value) {
            $sms.value = '';
        }
    });

    $('#Password').passStrength();

    if (isFromLoginOrCart(document.referrer)) {
        const storedEmail = emailStore.get();

        if (storedEmail) {
            $email.value = storedEmail;
            emailStore.clear();
        }
    }
}

function barnInformation($form, formData) {
    const openClass = 'barnFieldsOpen';
    const $content = $form.querySelector('#BarnManagerInfo');
    const $container = $form.querySelector('#BarnFields');
    const $check = $form.querySelector('#IsBarn');

    if (!$container || !$content || !$check) {
        throw new Error('barnInformation\'s $form element should contain specific child elements');
    }

    const show = () => {
        $content.style.display = 'block';
        $container.classList.add(openClass);
    };

    const hide = () => {
        $content.style.display = 'none';
        $container.classList.remove(openClass);
    };

    if (formData.get(fields.Business_Name)
        && formData.get(fields.Address1)
        && formData.get(fields.City)
        && formData.get(fields.Postal_Code)
        && formData.get(fields.State_Id) !== '-1'
    ) {
        show();
    }

    $check.addEventListener('click', () => {
        if ($check.checked) {
            show();
            return;
        }

        hide();
    });
}

function isFromLoginOrCart(url) {
    const { pathname } = new URL(url);
    return pathname === '/account/login' || pathname === '/cart';
}